module.exports = __webpack_public_path__ + "static/media/Analyis-Green.16871adb.svg";